import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';

export default function MountingOptions() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.MountingOptions');
    const [activeTab, setActiveTab] = useState('1');

    return (
        <div className={styles.mountingOptions}>
            <div className="container">
                <div className="solution-item">
                    <div className="text-box">
                        <h2 className="sub-title">
                            {t('label')} <span className="title">{t('title')}</span>
                        </h2>
                        <div className="desc">{t('desc')}</div>
                    </div>
                    {activeTab == '1' && (
                        <>
                            <div className="bg-img">
                                <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713523870401/house2.jpg" />
                            </div>

                            <div className="bg-img-h5">
                                <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713523912548/house3.jpg" />
                            </div>
                        </>
                    )}
                    {activeTab == '2' && (
                        <>
                            <div className="bg-img">
                                <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713523865768/house1.jpg" />
                            </div>

                            <div className="bg-img-h5">
                                <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713523917363/house4.jpg" />
                            </div>
                        </>
                    )}

                    <div className="tab-box">
                        <div className="tab-content">
                            <h3 className={`tab-item ${activeTab === '1' ? 'tab-item-active' : ''}`} onClick={() => setActiveTab('1')}>
                                {t('tab1')}
                            </h3>
                            <h3 className={`tab-item ${activeTab === '2' ? 'tab-item-active' : ''}`} onClick={() => setActiveTab('2')}>
                                {t('tab2')}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
